export default function Square() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="15"
      viewBox="0 0 143.937 81.359"
    >
      <g
        id="_8c54389548b4d9e831e8df59dd38f593"
        data-name="8c54389548b4d9e831e8df59dd38f593"
        transform="translate(-10 -144.169)"
      >
        <g id="Gruppe_1" data-name="Gruppe 1" transform="translate(10 144.169)">
          <path
            id="Pfad_1"
            data-name="Pfad 1"
            d="M13.82-366.622a4.623,4.623,0,0,0-3.2,2.082l-.617.983v37.441c0,31.289.059,37.579.411,38.2a5.385,5.385,0,0,0,2.91,2.2c.587.183,21.451.252,68.7.252,56.331,0,68.025-.046,68.818-.32a5.111,5.111,0,0,0,3-2.7c.088-.412.117-17.588.088-38.173l-.088-37.4-.793-.937a5.4,5.4,0,0,0-1.909-1.349c-1.087-.434-2.88-.434-68.7-.48C38.179-366.85,14.5-366.782,13.82-366.622Zm72.873,36.893v28.018h48.778v-24.5l4.643.069,4.613.069.088,15.851.059,15.828H77.29v-56.264H28.512v24.472h-9.4v-31.564H86.695v28.019Z"
            transform="translate(-10 366.831)"
          />
        </g>
      </g>
    </svg>
  );
}
